import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { lineHeight, fontNormal, spacing, borderRadius, actionColor, white, gray20, gray70, errorColor, fontNormalBig, gray80, gray95 } from '@propellerads/stylevariables';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed !important;\n        background-color: ", " !important;\n        box-shadow: none !important;;\n        color: gray !important;\n        \n        &:hover {\n            box-shadow: none !important;;\n        }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        cursor: progress !important;\n        position: relative;\n        color: transparent;\n        \n        &:before {\n            content: '';\n            position: absolute;\n            height: 20px;\n            width: 20px;\n            border: 3px solid;\n            border-color: white ", " ", ";\n            opacity: 0.7;\n            border-radius: 50%;\n            animation: spin 0.5s linear infinite;\n            margin-left: auto;\n            margin-right: auto;\n        }\n        \n        &:hover {\n             color: transparent;\n        } \n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        line-height: ", "px;\n        padding: 0 24px;\n        font-size: ", "px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n\n        &:hover {\n          box-shadow: inset 0 0 0 1px hsl(0, 85%, 45%);\n        }\n        \n        &:active {\n          box-shadow: inset 0 0 0 1px hsl(0, 85%, 45%);\n        }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        height: auto;\n        padding: 0;\n        background: transparent;\n        border-radius: 0;\n        line-height: 1;\n        font-weight: normal;\n      \n        &:hover {\n        }\n        \n        &:active {\n        }\n        \n        &:disabled {\n            background-color: transparent !important;\n        }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        background-color: transparent;\n        color: ", ";\n        line-height: inherit;\n        height: auto;\n        padding: 0;\n        border: 0;\n        background-color: transparent\n      \n        &:hover {\n            color: hsl(210, 100%, 20%); \n        }\n        \n        &:disabled {\n            background-color: transparent !important;\n        }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        background-color: white;\n        color: ", ";\n        box-shadow: inset 0 0 0 1px ", ";\n      \n        &:hover {\n          box-shadow: inset 0 0 0 1px hsl(210, 100%, 45%);\n        }\n        \n        &:active {\n          box-shadow: inset 0 0 0 1px hsl(210, 100%, 40%);\n        }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        box-shadow: inset 0 0 0 1px ", ";\n        \n        &:hover {\n            background-color: hsl(0, 0%, 90%);\n            box-shadow: inset 0 0 0 1px grey;\n            color: black;\n        }\n        \n        &:active {\n            background-color: hsl(0, 0%, 95%);\n            color: ", ";\n        }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        \n        &:hover {\n            background-color: hsl(210, 100%, 60%);\n            color: ", ";\n        }\n        \n        &:active {\n            background-color: hsl(210, 100%, 45%);\n            color: ", ";\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    font-weight: 400;\n    cursor: pointer;\n    height: ", "px;\n    line-height: ", "px;\n    font-size: ", "px;\n    padding: 0 ", "px;\n    justify-content: center;\n    white-space: nowrap;\n    user-select: none;\n    border: 0;\n    border-radius: ", "px;\n    transition: background-color 0.1s linear 0s, border-color 0.1s linear 0s;\n    outline: none;\n      \n    ", "\n\n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var BUTTON_TYPE = {
  PRIMARY: 'isPrimary',
  SECONDARY: 'isSecondary',
  ADVANCED: 'isAdvanced',
  LINK: 'isLink',
  PLAIN: 'isPlain',
  DANGER: 'isDanger'
};
var BUTTON_SIZE = {
  DEFAULT: 'isDefault',
  BIG: 'isBig'
};
var StyledButton = styled.button.attrs(function (props) {
  return {
    disabled: props.isDisabled || props.isLoading
  };
})(_templateObject(), lineHeight, lineHeight, fontNormal, spacing * 4, borderRadius, function (props) {
  return props.type === BUTTON_TYPE.PRIMARY && css(_templateObject2(), actionColor, white, white, white);
}, function (props) {
  return props.type === BUTTON_TYPE.SECONDARY && css(_templateObject3(), white, gray20, gray70, gray20);
}, function (props) {
  return props.type === BUTTON_TYPE.ADVANCED && css(_templateObject4(), actionColor, actionColor);
}, function (props) {
  return props.type === BUTTON_TYPE.LINK && css(_templateObject5(), actionColor);
}, function (props) {
  return props.type === BUTTON_TYPE.PLAIN && css(_templateObject6());
}, function (props) {
  return props.type === BUTTON_TYPE.DANGER && css(_templateObject7(), errorColor, white);
}, function (props) {
  return props.size === BUTTON_SIZE.BIG && css(_templateObject8(), lineHeight * 2, lineHeight * 2, fontNormalBig);
}, function (props) {
  return props.isLoading && css(_templateObject9(), gray80, gray80);
}, function (props) {
  return props.isDisabled && css(_templateObject10(), gray95);
}, function (props) {
  return props.isFullWidth && css(_templateObject11());
});

var Button = function Button(_ref) {
  var isLoading = _ref.isLoading,
      onChangePromise = _ref.onChangePromise,
      type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      isFullWidth = _ref.isFullWidth,
      elementId = _ref.elementId,
      isAsync = _ref.isAsync,
      isDisabled = _ref.isDisabled,
      children = _ref.children,
      gtmAction = _ref.gtmAction,
      gtmLabel = _ref.gtmLabel,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  var _useState = useState(isLoading),
      _useState2 = _slicedToArray(_useState, 2),
      isStateLoading = _useState2[0],
      setLoading = _useState2[1];

  var asyncOnclick;

  if (isAsync && onClick) {
    asyncOnclick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return onClick();

              case 4:
                _context.prev = 4;
                setLoading(false);
                return _context.finish(4);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0,, 4, 7]]);
      }));

      return function asyncOnclick() {
        return _ref2.apply(this, arguments);
      };
    }();
  }

  useEffect(function () {
    setLoading(isLoading);
  }, [isLoading]);

  function handleClickDeprecated() {
    setLoading(true);
    return onChangePromise()["finally"](function () {
      setLoading(false);
    });
  }

  return /*#__PURE__*/React.createElement(StyledButton, {
    type: type,
    size: size,
    onClick: asyncOnclick || onClick || handleClickDeprecated,
    isDisabled: asyncOnclick ? isStateLoading || isDisabled : isDisabled,
    id: elementId,
    className: "Button",
    "gtm-action": gtmAction,
    "gtm-label": gtmLabel,
    "data-is-loading": isStateLoading,
    isLoading: isLoading || isStateLoading,
    isFullWidth: isFullWidth,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
};

Button.propTypes = {
  elementId: PropTypes.string.isRequired,
  onChangePromise: PropTypes.func,
  // deprecated
  onClick: PropTypes.func,
  isAsync: PropTypes.bool,
  isDisabled: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(BUTTON_TYPE)),
  size: PropTypes.oneOf(Object.values(BUTTON_SIZE)),
  isFullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
  gtmAction: PropTypes.string,
  gtmLabel: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
Button.defaultProps = {
  onChangePromise: undefined,
  onClick: undefined,
  isAsync: false,
  isDisabled: false,
  type: BUTTON_TYPE.PLAIN,
  size: BUTTON_SIZE.DEFAULT,
  isFullWidth: false,
  isLoading: false,
  gtmAction: undefined,
  gtmLabel: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined
};

export default Button;
export { BUTTON_SIZE, BUTTON_TYPE };
